import { render, staticRenderFns } from "./TheEditGroupPanel.vue?vue&type=template&id=98267b5e"
import script from "./TheEditGroupPanel.vue?vue&type=script&lang=js"
export * from "./TheEditGroupPanel.vue?vue&type=script&lang=js"
import style0 from "./TheEditGroupPanel.vue?vue&type=style&index=0&id=98267b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports